const addPlurals = (number: number, language: string = 'ru') => {
  return language === 'ru'
    ? /1[0-9]$/.test(`${number}`)
      ? 'few_seats'
      : /(([2-9]+(?=1))|(^1$))/.test(`${number}`)
      ? 'seat'
      : /((0)$|([5-9]$))/.test(`${number}`)
      ? 'few_seats'
      : 'seats'
    : /^1$/.test(`${number}`)
    ? 'seat'
    : 'seats';
};

export default addPlurals;
